import App from './App.vue'
import '../assets/css/index.css';

import { createApp } from 'vue';

// Vue.config.productionTip = false

// Vue.use(VueRouter)

const app = createApp(App);

app.mount('#app');
  